'use strict';

import angular from 'angular';
import constants from '../../app/app.constants';
import util from '../util/util.module';
import { CanvasService } from './canvas.service';
import { LayoutService } from './layout.service';
import { SubmitLayoutService } from './submitLayout.service';
import { BackgroundImagesService } from './backgroundImages.service';
import { ClipArtImagesService } from './clipArtImages.service';
import { StageDirective } from './stage.directive';
import { ToolbarPanelDirective } from './toolbarPanel.directive';
import { LayoutPreviewDirective } from './layoutPreview.directive';
import { ColorPickerDirective } from './colorPicker.directive';

export default angular.module('komCanvasConfiguratorApp.canvas', [constants, util])
  .factory('Canvas', CanvasService)
  .factory('LayoutDefinition', LayoutService)
  .factory('BackgroundImages', BackgroundImagesService)
  .factory('ClipArtImages', ClipArtImagesService)
  .factory('SubmitLayout', SubmitLayoutService)
  .directive('uiStage', StageDirective)
  .directive('uiToolbarPanel', ToolbarPanelDirective)
  .directive('uiLayoutPreview', LayoutPreviewDirective)
  .directive('uiColorpicker', ColorPickerDirective)
  .name;



// WEBPACK FOOTER //
// ./client/components/canvas/canvas.module.js